import React from 'react';

const FormatageDate = ({date}) => {
    const newDate = new Date(date);
    const today = new Date();

    // Fonction pour vérifier si la date est aujourd'hui
    const isToday = (someDate) => {
        return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear();
    };

    // Formatage de la date
    const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    };

    // Ajout de l'heure uniquement si la date est aujourd'hui
    if (isToday(newDate)) {
        dateOptions.hour = '2-digit';
        dateOptions.minute = '2-digit';
    }

    const formattedDate = newDate.toLocaleDateString('fr-FR', dateOptions);

    return (
        <span>{formattedDate}</span>
    );
};

export default FormatageDate;
